<template>
	<div class="o-wrap wraps">
		<div class="leftBox">
			<div class="header">
				<div class="head">
					<div class="demoLogo">
						<div class="block"><el-avatar :size="60" :src="circleUrl"></el-avatar></div>
					</div>
					<div class="demoText">
						<div class="title">鹿</div>
						<div class="sjBox">
							plus
						</div>
					</div>
				</div>
				<el-input v-model="input" placeholder="搜索最近联系人"></el-input>
			</div>
			<ul>
				<li v-for="(item,index) in tabLists" :class="{ on : index === isactive}" @click="tabList(item)" >
					<div class="logo">
						<img src="" alt="" />
					</div>
					<div class="text">
						{{item.name}}
					</div>
				</li>
			</ul>
		</div>
		<div class="centerBox">
			<div class="titleBox">
				<div class="logo">
					<img src="" alt="" />
				</div>
				宏基供应商客服
			</div>
			<div class="newsCounts">
				<div class="newsView">
					<div class="">
						<div class="newsBox">
							<div class="noNew">没有聊天记录了</div>
							<div class="end">————————— 上次聊到这里 —————————</div>
										
							<div class="kfBox">
								<div class="kfNews">
									哈哈哈哈哈哈哈哈哈哈
								</div>
								<div class="kfLogo">
									<img src="" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div class="newsChat">
						<textarea name="" id=""></textarea>
						<button>发送</button>
					</div>
				</div>
				<div class="laiyuan">
					<div class="tabTitle">
						<div class="title">
							来源
						</div>
					</div>
					<div class="listBox">
						<div class="list_box">
							<div class="left">
								<div class="logos">
									<img src="" alt="" />
								</div>
								<div class="title">
									河北中链企通
								</div>
								<!-- <div class="spanBox">
									<span>订单数0</span>
									<span>包裹数0</span>
								</div> -->
							</div>
							<div class="right">
								<el-input v-model="input2" placeholder="运单号/订单号"></el-input>
								<div class="sou">
									sou
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				circleUrl: '',
				input: '',
				input2: '',
				tabLists:[{name:"宏基供应商",index:0,id:0},{name:"哈哈哈哈哈",index:1,id:1},{name:"啦啦啦啦",index:2,id:2}],
				isactive:0
			}
		},
		created() {
			
		},
		mounted(){
			this.isactive = this.tabLists[0].index
		},
		methods: {
			tabList(item){
				console.log("e",item.index)
				this.isactive = item.index
			}
		}
	}
</script>
<style>
	ul li {
		list-style: none;
	}

	.o-wrap {
		display: flex;

	}

	.leftBox {
		width: 296px;
		padding: 0 5px;
		border: 1px solid #e1e1e1;
	}

	.leftBox .header {
		padding: 5px;
		background-color: #0194fe;
	}

	.leftBox .head {
		display: flex;
	}

	.leftBox .head .demoLogo {
		width: 59px;
		height: 59px;
	}

	.leftBox .head .demoLogo img {
		width: 59px;
		height: 59px;
	}

	.leftBox .head .demoText {
		margin-left: 15px;
	}

	.leftBox .head .demoText .title {
		color: #fff;
		line-height: 40px;
	}

	.leftBox .head .demoText .sjBox {
		color: #fff;
	}

	.leftBox .el-input__inner {
		width: 278px;
		height: 30px;
		margin: 10px 0;

	}

	.leftBox ul {
		padding-inline-start: 0;
	}

	.leftBox ul li {
		height: 36px;
		padding: 15px;
		margin-left: 0;
		cursor: pointer;
		display: flex;
		justify-content: start;
	}

	.leftBox ul li.on {
		background-color: rgba(188, 215, 240, 0.6);
	}

	.leftBox ul li .logo {
		width: 36px;
		height: 36px;
		margin-right: 12px;
	}

	.leftBox ul li .logo img {
		width: 36px;
		height: 36px;
	}

	.leftBox ul li .text {
		width: 220px;
		height: 26px;
		line-height: 26px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}

	.centerBox {
		width: 1046px;
	}

	.centerBox .titleBox {
		/* width: 650px; */
		padding: 12px 0 12px 12px;
		background-color: #fafafa;
		display: flex;
		font-size: 16px;
		font-weight: 500;
	}

	.centerBox .titleBox .logo {
		width: 50px;
		height: 50px;
		margin-right: 20px;
	}

	.centerBox .titleBox .logo img {
		width: 50px;
		height: 50px;
	}
	.centerBox .newsCounts{
		display: flex;
		justify-content: space-between;
	}
	.centerBox .newsCounts .newsView{
		width: 650px;
		height: 600px;
		border-top: 1px solid #e1e1e1;
		border-bottom: 1px solid #e1e1e1;
	}
	.centerBox .newsCounts .newsBox{
		height: 400px;
		padding: 0 20px;
		overflow-y: scroll;
	}
	.centerBox .newsCounts .newsChat{
		width: 650px;
		height: 200px;
		border-top: 1px solid #e1e1e1;
		position: relative;
	}
	.centerBox .newsCounts .newsChat textarea{
		position: absolute;
		width: 630px;
		height: 200px;
		font-size: 15px;
		line-height: 30px;
		outline: none;
		border: 0;
		padding: 10px;
		text-indent: 28px;
	}
	.centerBox .newsCounts .newsChat button{
		position: absolute;
		right: 0;
		bottom: 0;
		width: 120px;
		height: 40px;
		outline: none;
		border: 0;
		color: #fff;
		cursor: pointer;
		background-color: #0194fe;
	}
	
	.noNew{
		line-height: 40px;
		color: #666;
		font-size: 14px;
	}
	.end{
		line-height: 40px;
		color: #999;
		font-size: 14px;
		text-align: center;
	}
	.kfBox{
		display: flex;
		justify-content: end;
		align-items: center;
	}
	.kfBox .kfLogo{
		width:54px;
		height:54px;
		margin: 0 15px;
	}
	.kfBox .kfLogo img{
		width:54px;
		height:54px;
	}
	.kfBox .kfNews{
		padding: 5px 10px;
		line-height: 25px;
		font-size: 14px;
		border: 1px solid #e1e1e1;
	}
	.laiyuan{
		width: 400px;
		border: 1px solid #e1e1e1;
	}
	.laiyuan .tabTitle{
		height: 30px;
		line-height: 30px;
		color: #fff;
		font-size: 13px;
		text-align: left;
		background: #0194fe;
		text-indent: 15px;
		border-bottom: 1px solid #0194fe;
	}
	.listBox .list_box{
		padding: 12px;
		display: flex;
		align-items: center;
	}
	.listBox .list_box .left,.listBox .list_box .right{
		display: flex;
		align-content: center;
		font-size: 12px;
	}
	.listBox .list_box .left .title{
		width: 120px;
		height: 30px;
		line-height: 30px;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-left: 12px;
	
	}
	.spanBox{
		width: 70px;
	}
	.listBox .list_box .logos{
		width: 36px;
		height: 36px;
	}
	.listBox .list_box .logos img{
		width: 36px;
		height: 36px;
	}
	.listBox .list_box .right{
		margin-left: 10px;
	}
	.listBox .list_box .right .el-input__inner{
		width:140px !important;
		height: 25px !important;
		
	}
	.listBox .list_box .right .sou{
		width: 25px;
		height: 25px !important;
		line-height: 25px !important;
	}
	
</style>